import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { CloseIcon, FilterIcon } from 'air-icons';
import AirButton from 'air-button';

import './FiltersButton.css';

@inject('translationsStore', 'filterStore')
@observer
export default class FiltersButton extends Component {

  render() {
    const { translationsStore, filterStore } = this.props;
    let filtersNum = 0;
    // let areFiltered = () => filterStore.appliedFiltersLength > 0;
    if (filterStore.appliedFiltersLength) {
      filtersNum = filterStore.appliedFiltersLengthFor('carFilter_');
    }

    return (
      <div className="FiltersButton">
        {filtersNum === 0 && (
          <AirButton
            onClick={this.props.onFiltersClick}
            className="openFilter"
            icon={<FilterIcon style={{ color: 'white' }} />}
            label={translationsStore.translate('carList.advancedFilter')}
          />
        )}
        {filtersNum > 0 && (
          <div className="filterActiveButton">
            <FilterIcon style={{ color: 'white', width: '18px', height: '12px' }} className="filterIcon" onClick={this.props.onFiltersClick} />
            <div>
              {translationsStore.translate('carList.advancedFilter')} {filtersNum}
            </div>
            <CloseIcon title="reset" style={{ color: 'white', width: '14px', height: '14px' }} className="closeIcon" onClick={this.props.onResetClick} />
          </div>
        )}
      </div>
    );
  }
}
